import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { PatientService } from '../../../services/patient.service';
import { AuthService } from '../../../services/auth/auth.service';
import { MedicionEstadoApi } from '../../../services/lbsdk/services/custom/MedicionEstado';
import { Constants } from '../../../constants';
import { Medicion, MedicionApi } from '../../../services/lbsdk';
import { HttpClient } from '@angular/common/http';
import { isNumber } from 'ionic-angular/umd/util/util';

/**
 * Generated class for the FichaDataPacientPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ficha-data-pacient',
  templateUrl: 'ficha-data-pacient.html',
})
export class FichaDataPacientPage {

  /* VARIABLES PARA  MEDICIONES RECETA */
  odEsferica: string = null;
  odCilindro: string = null;
  odEje: string = null;

  oiEsferica: string = null;
  oiCilindro: string = null;
  oiEje: string = null;

  addDerecho: string = null;
  oddDerecho: string = null;

  addIzquierdo: string = null;
  oddIzquierdo: string = null;



  resultPaciente;
  estados;
  logStatePatient;
  /*estados = [{ id: 1, descripcion: "Pendiente" },
  { id: 2, descripcion: "Medido" }]*/
  estado;

  nroArreglo: string;
  nroSobre: string;

  urlReceta: string = "";
  urlModelo: string = "";
  id;
  offset
  constructor(public navCtrl: NavController, public navParams: NavParams, private patientApi: PatientService,
    private toastController: ToastController, private authService: AuthService, private statePacient: MedicionEstadoApi,
    private medicionApi: MedicionApi, private http: HttpClient, private loadingCtrl: LoadingController) {
    //   this.resultPaciente = navParams.data;
    this.offset = new Date().getTimezoneOffset();
    this.id = navParams.data.idMedicion;

    //    this.actualizarDatosMedicion();

    // this.resultPaciente = navParams.data;
    // console.log("DATOS FICHA ******************************", this.resultPaciente)
    // this.nroArreglo = this.resultPaciente.nroArreglo;
    // this.nroSobre = this.resultPaciente.nroSobre;
    // //Carga la lista de estados del paciente.
    // this.updateStateLog();

    // this.estado = this.resultPaciente.state == undefined ? 1 : this.resultPaciente.state;

    // this.urlReceta = Constants.urlFotos + navParams.data.idMedicion + '/download/recete.jpeg';
    // this.urlModelo = Constants.urlFotos + navParams.data.idMedicion + '/download/modelo.jpeg';

  }
  async verPdf() {
    let loader = this.loadingCtrl.create({
      content: 'Procesando...'
    });
    loader.present();
    let parameter = "IDMEDICION=" + this.navParams.data.idMedicion
    this.http.post(Constants.hostApiNode + "/api/ConsultasSqls/GetReportPdf", { nameReport: "rptInforme", queryParameter: parameter, movil: true })
      .subscribe(respuesta => {
        loader.dismiss();
        console.log("REPUESTA PDF", respuesta)

        var byteCharacters = atob(respuesta['$data']);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

      }, error => {
        console.log('Error creating file', error);
        alert("En este momento no es posible generar el Pdf. (Cód 03): " + error)
      });

  }
  actualizarDatosMedicion() {
    this.id = this.navParams.data.idMedicion;
    this.medicionApi.findById(this.id)
      .subscribe((respuesta: Medicion) => {
        let medicion: Medicion = respuesta
        console.log("DATOS FIND ", respuesta)

        let data = {
          idMedicion: medicion.idmedicion,
          _id: medicion.idMongo,
          id: medicion.idMongo,
          company: medicion.company,
          emailCompany: medicion.emailcompany,
          name: medicion.name,
          lastname: medicion.lastname,
          number: medicion.number,
          recipe: {
            frameModel: medicion.recipeframemodel,
            framePicture: medicion.recipeframepicture,
            recipePicture: medicion.reciperecipepicture,
            recipe: medicion.reciperecipe
          },
          image: medicion.image,
          result: {
            markers: {
              left: [
                medicion.resultmarkersleft1,
                medicion.resultmarkersleft2
              ],
              right: [
                medicion.resultmarkersright1,
                medicion.resultmarkersright2
              ]
            },
            pupils: {
              left: [
                medicion.resultpupilsleft1,
                medicion.resultpupilsleft2
              ],
              right: [
                medicion.resultpupilsright1,
                medicion.resultpupilsright2
              ]
            },
            frame: {
              top: {
                left: [
                  medicion.resultframetopleft1,
                  medicion.resultframetopleft2
                ],
                right: [
                  medicion.resultframetopright1,
                  medicion.resultframetopright2
                ]
              },
              bot: {
                left: [
                  medicion.resultframebotleft1,
                  medicion.resultframebotleft2
                ],
                right: [
                  medicion.resultframebotright1,
                  medicion.resultframebotright2
                ]
              }
            },
            noseBridge: {
              top: [
                medicion.resultnosebridgetop1,
                medicion.resultnosebridgetop2
              ],
              bot: [
                medicion.resultnosebridgebot1,
                medicion.resultnosebridgebot2
              ]
            },
            mmCameraDistance: medicion.resultmmcameradistance,
            pxMarkersDistance: medicion.resultpxmarkersdistance,
            pxPupilsDistance: medicion.resultpxpupilsdistance,
            pxLeftPupilToBridge: medicion.resultpxleftpupiltobridge,
            pxRightPupilToBridge: medicion.resultpxrightpupiltobridge,
            pxLeftPupilToTopFrame: medicion.resultpxleftpupiltotopframe,
            pxLeftPupilToBotFrame: medicion.resultpxleftpupiltobotframe,
            pxRightPupilToTopFrame: medicion.resultpxrightpupiltotopframe,
            pxRightPupilToBotFrame: medicion.resultpxrightpupiltobotframe,
            mmTotalPupilDistance: medicion.resultmmtotalpupildistance,
            mmMarkersDistance: medicion.resultmmmarkersdistance,
            mmPupilsDistance: medicion.resultmmpupilsdistance,
            mmLeftPupilToBridge: medicion.resultmmleftpupiltobridge,
            mmRightPupilToBridge: medicion.resultmmrightpupiltobridge,
            mmLeftPupilToTopFrame: medicion.resultmmleftpupiltotopframe,
            mmLeftPupilToBotFrame: medicion.resultmmleftpupiltobotframe,
            mmRightPupilToTopFrame: medicion.resultmmrightpupiltotopframe,
            mmRightPupilToBotFrame: medicion.resultmmrightpupiltobotframe,
          },
          created: medicion.created,
          avatar: "",
          empresa: medicion.empresa,
          state: medicion.idestado,
          nroSobre: medicion.nrosobre,
          nroArreglo: medicion.nroarreglo,
          odEsferica: medicion.odEsferica,
          odCilindro: medicion.odCilindro,
          odEje: medicion.odEje,
          oiEsferica: medicion.oiEsferica,
          oiCilindro: medicion.oiCilindro,
          oiEje: medicion.oiEje,
          addDerecho: medicion.addDerecho,
          oddDerecho: medicion.oddDerecho,
          addIzquierdo: medicion.addIzquierdo,
          oddIzquierdo: medicion.oddIzquierdo

        }
        console.log("RESULTADO ", data)

        this.resultPaciente = data;

        this.nroArreglo = this.resultPaciente.nroArreglo;
        this.nroSobre = this.resultPaciente.nroSobre;

        this.odEsferica = this.resultPaciente.odEsferica;
        this.odCilindro = this.resultPaciente.odCilindro;
        this.odEje = this.resultPaciente.odEje
        this.oiEsferica = this.resultPaciente.oiEsferica;
        this.oiCilindro = this.resultPaciente.oiCilindro;
        this.oiEje = this.resultPaciente.oiEje
        this.oddDerecho = this.resultPaciente.oddDerecho
        this.addDerecho = this.resultPaciente.addDerecho
        this.oddIzquierdo = this.resultPaciente.oddIzquierdo
        this.addIzquierdo = this.resultPaciente.addIzquierdo

        //Carga la lista de estados del paciente.
        this.updateStateLog();

        this.estado = this.resultPaciente.state == undefined ? 1 : this.resultPaciente.state;

        this.urlReceta = Constants.urlFotos + this.navParams.data.idMedicion + '/download/recete.jpeg';
        this.urlModelo = Constants.urlFotos + this.navParams.data.idMedicion + '/download/modelo.jpeg';

      }, error => {
        console.log("eeror al recuperadr datos")
      })
  }
  ionViewDidEnter() {
    this.actualizarDatosMedicion();
    /* console.log("DATOS ENVIADOS ", this.navParams.data)
     this.resultPaciente = this.navParams.data;
     console.log("DATOS FICHA ******************************", this.resultPaciente)
     this.nroArreglo = this.resultPaciente.nroArreglo;
     this.nroSobre = this.resultPaciente.nroSobre;
     //Carga la lista de estados del paciente.
     this.updateStateLog();
 
     this.estado = this.resultPaciente.state == undefined ? 1 : this.resultPaciente.state;
 
     this.urlReceta = Constants.urlFotos + this.navParams.data.idMedicion + '/download/recete.jpeg';
     this.urlModelo = Constants.urlFotos + this.navParams.data.idMedicion + '/download/modelo.jpeg';*/
  }
  ionViewDidLoad() {

    this.patientApi.getState()
      .subscribe(est => {

        this.estados = est;

      })
    // this.nroArreglo = this.resultPaciente.nroArreglo;
    // this.nroSobre = this.resultPaciente.nroSobre;
    // //Carga la lista de estados del paciente.
    // this.updateStateLog();

    // this.estado = this.resultPaciente.state == undefined ? 1 : this.resultPaciente.state;
    // this.estado = this.resultPaciente.state;
  }

  //VER SI SE PUEDE ACTUALIZAR DESDE EL TAB. METODO CUANDO SE ACTIVA LA PAGINA


  /*this.patientApi.findById(this.resultPaciente.id,null)
    .subscribe(data => {
      this.resultPaciente = data;
     this.nroArreglo = this.resultPaciente.nroArreglo;
     this.nroSobre = this.resultPaciente.nroSobre;
    })*/



  //Consulta los estados que ha tenido el paciente.
  updateStateLog() {

    this.statePacient.find({
      where: { idmedicion: this.resultPaciente.idMedicion },
      include: ["Usuario", "Estado"]
    })
      .subscribe(res => {
        //
        console.log("ESTADOS ", res)
        this.logStatePatient = res;
      })
  }
  changePage(page) {

    switch (page) {
      case "modelo": {
        this.navCtrl.parent.select(3);
        break;
      }
      case "receta": {
        this.navCtrl.parent.select(2);
        break;
      }
      default: {
        this.navCtrl.parent.select(1);
        break;
      }
    }
  }

  cargarNumeros() {
    console.log("od esferica ", this.odEsferica)
  
    this.medicionApi.patchAttributes(this.resultPaciente.idMedicion, {
      nrosobre: this.nroSobre,
      nroarreglo: this.nroArreglo,
      odEsferica: this.odEsferica == "" ? null : this.odEsferica,
      odCilindro: this.odCilindro == "" ? null : this.odCilindro,
      odEje:this.odEje == "" ? null : this.odEje,
      oiEsferica: this.oiEsferica == "" ? null : this.oiEsferica,
      oiCilindro: this.oiCilindro == "" ? null : this.oiCilindro,
      oiEje: this.oiEje == "" ? null : this.oiEje,
      addDerecho: this.addDerecho == "" ? null : this.addDerecho,
      oddDerecho: this.oddDerecho == "" ? null : this.oddDerecho,
      addIzquierdo: null,//this.addIzquierdo == "" ? null : this.addIzquierdo,
      oddIzquierdo: null//this.oddIzquierdo == "" ? null : this.oddIzquierdo,

    })
      .subscribe(res => {
        //   this.patientApi.updateNros(this.nroSobre, this.nroArreglo, this.resultPaciente.id).subscribe(res => { })
        this.presentToast("Se actualizo correctamente.")
        this.updateStateLog();
      }, error => {
        this.presentToast("No se logro actualizar los datos indicados.")
        // this.updateStateLog();
      })
    /*  this.patientApi.updateNros(this.nroSobre, this.nroArreglo, this.resultPaciente.id)
        .flatMap((data) => {
          this.resultPaciente = data;
          return this.statePacient.create({ idUser: this.authService.userData.user.id, idState: this.estado, idPatient: this.resultPaciente.id })
        })
        .subscribe(res => {
          this.patientApi.updateNros(this.nroSobre, this.nroArreglo, this.resultPaciente.id).subscribe(res => { })
          this.presentToast("Se actualizo correctamente.")
          this.updateStateLog();
        }, error => {
          this.presentToast("No se logro actualizar los datos indicados.")
          // this.updateStateLog();
        })*/

  }
  cambiarEstado() {

    this.medicionApi.patchAttributes(this.resultPaciente.idMedicion, { idestado: this.estado })
      .flatMap((data) => {

        return this.statePacient.create({ idusuario: this.authService.userData.user.idusuario, idstate: this.estado, idmedicion: this.resultPaciente.idMedicion })
      })
      .subscribe(respuesta => {
        if (this.estado == 5) {
          this.resultPaciente.state = 5;
        }
        this.updateStateLog();
        this.presentToast("Se actualizo el estado correctamente.")
      })
    /*this.patientApi.updateState(this.estado, this.resultPaciente.id)
      .flatMap((data) => {
        this.resultPaciente = data;
        return this.statePacient.create({ idUser: this.authService.userData.user.id, idState: this.estado, idPatient: this.resultPaciente.id })
      })
      .subscribe(res => {
        this.patientApi.updateStateSql(this.estado, this.resultPaciente.id).subscribe(res=>{})
        this.presentToast("Se actualizo el estado correctamente.")
        this.updateStateLog();
      },error=>{
        this.presentToast("No se logro actualizar los datos indicados.")
       // this.updateStateLog();
      })*/


  }

  //MUESTRA MENSAJE
  presentToast(msg) {
    let toast = this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ficha-tabs/ficha-data-pacient/ficha-data-pacient.ts